<div class="agent-wrapper">
    <div class="container-fluid">
        <ng-container *ngIf="CoBrandingState$ | async as coBranding">

            <!--Standard Single Agent-->
            <ng-container *ngIf="coBranding == 'None'">
                <div class="row">
                    <div class="col-12">
                        <div class="agent-card" *ngIf="LgvUserSvc.AgentDTO$ | async as agentDTO">
                            <div class="row">
                                <!-- Image Column -->
                                <div class="col-12 col-sm-3 col-md-2 col-lg-2 agent-info"  >
                                    <img class="agent-image" [src]="agentDTO.agentInfo.profileImageUrl"
                                        [alt]="agentDTO.agentInfo.firstName + ' ' + agentDTO.agentInfo.lastName" />
                                </div>
                                <!-- Agent Info Column -->
                                <div class="col-12 col-sm-9 col-md-6 col-lg-6">
                                    <div class="agent-name">{{agentDTO.agentInfo.firstName}}
                                        {{agentDTO.agentInfo.lastName}}</div>
                                    <div class="agent-title">{{agentDTO.agentInfo.jobTitle}}</div>
                                    <div class="agent-company-info">
                                        <div class="company-section">
                                            <div class="company-name">{{agentDTO.company?.name || 'Real-Finity Mortgage, LLC'}}</div>
                                            <div class="company-address">{{agentDTO.agentInfo.address1 || '929 Alton Road Suite 500, Miami, FL 33139'}}
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Contact section embedded in info column for sm breakpoint -->
                                    <div class="contact-section d-block d-sm-block d-md-none">
                                        <div class="email-link" (click)="OnSendEmail()">Email me</div>
                                        <div class="website-link" *ngIf="agentDTO.agentInfo.website">Visit my website</div>
                                        <div class="contact-info">
                                            <div class="contact-item" *ngIf="agentDTO.agentInfo.phone">
                                                <div class="contact-icon phone-icon">
                                                    <div class="icon-text">o</div>
                                                </div>
                                                <div class="contact-number">{{agentDTO.agentInfo.phone}}</div>
                                            </div>
                                            <div class="contact-item" *ngIf="agentDTO.agentInfo.mobilePhone">
                                                <div class="contact-icon mobile-icon">
                                                    <div class="icon-text">c</div>
                                                </div>
                                                <div class="contact-number">{{agentDTO.agentInfo.mobilePhone}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Contact Info Column (hidden on sm, visible on md+) -->
                                <div class="col-12 col-sm-12 col-md-4 d-none d-md-block">
                                    <div class="contact-section">
                                        <div class="email-link" (click)="OnSendEmail()">Email me</div>
                                        <div class="website-link" *ngIf="agentDTO.agentInfo.website">Visit my website
                                        </div>
                                        <div class="contact-info">
                                            <div class="contact-item" *ngIf="agentDTO.agentInfo.phone">
                                                <div class="contact-icon phone-icon">
                                                    <div class="icon-text">o</div>
                                                </div>
                                                <div class="contact-number">{{agentDTO.agentInfo.phone}}</div>
                                            </div>
                                            <div class="contact-item" *ngIf="agentDTO.agentInfo.mobilePhone">
                                                <div class="contact-icon mobile-icon">
                                                    <div class="icon-text">c</div>
                                                </div>
                                                <div class="contact-number">{{agentDTO.agentInfo.mobilePhone}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!--Standard Cobranded Agents-->
            <ng-container *ngIf="coBranding == 'CoBranded'">
                <div class="row">
                    <!-- First Agent (Main Agent) -->
                    <div class="col-12 col-md-6">
                        <div class="agent-card" *ngIf="LgvUserSvc.AgentDTO$ | async as agentDTO">
                            <div class="row">
                                <!-- Image Column -->
                                <div class="col-12 col-sm-3 col-md-3 agent-info">
                                    <img class="agent-image" [src]="agentDTO.agentInfo.profileImageUrl"
                                        [alt]="agentDTO.agentInfo.firstName + ' ' + agentDTO.agentInfo.lastName" />
                                </div>
                                <!-- Info Column -->
                                <div class="col-12 col-sm-9 col-md-9 col-lg-5">
                                    <div class="agent-name">{{agentDTO.agentInfo.firstName}}
                                        {{agentDTO.agentInfo.lastName}}</div>
                                    <div class="agent-title">{{agentDTO.agentInfo.jobTitle}}</div>
                                    <div class="agent-company-info">
                                        <div class="company-section">
                                            <div class="company-name">{{agentDTO.company?.name || 'Real-Finity Mortgage, LLC'}}</div>
                                            <div class="company-address">{{agentDTO.agentInfo.address1 || '929 Alton Road Suite 500, Miami, FL 33139'}}</div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Contact Column -->
                                <div class="col-12 col-sm-12 col-md-12 col-lg-4">
                                    <div class="contact-section">
                                        <div class="email-link" (click)="OnSendEmail()">Email me</div>
                                        <div class="website-link" *ngIf="agentDTO.agentInfo.website">Visit my website
                                        </div>
                                        <div class="contact-info">
                                            <div class="contact-item" *ngIf="agentDTO.agentInfo.phone">
                                                <div class="contact-icon phone-icon">
                                                    <div class="icon-text">o</div>
                                                </div>
                                                <div class="contact-number">{{agentDTO.agentInfo.phone}}</div>
                                            </div>
                                            <div class="contact-item" *ngIf="agentDTO.agentInfo.mobilePhone">
                                                <div class="contact-icon mobile-icon">
                                                    <div class="icon-text">c</div>
                                                </div>
                                                <div class="contact-number">{{agentDTO.agentInfo.mobilePhone}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Second Agent (Co-branded Agent) -->
                    <div class="col-12 col-md-6">
                        <div class="agent-card" *ngIf="LgvUserSvc.CoBrandedAgentDTO$ | async as coBrandedAgentDTO">
                            <div class="row">
                                <!-- Image Column -->
                                <div class="col-12 col-sm-3 col-md-3 agent-info">
                                    <img class="agent-image" [src]="coBrandedAgentDTO.agentInfo.profileImageUrl"
                                        [alt]="coBrandedAgentDTO.agentInfo.firstName + ' ' + coBrandedAgentDTO.agentInfo.lastName" />
                                </div>
                                <!-- Info Column -->
                                <div class="col-12 col-sm-9 col-md-9 col-lg-5">
                                    <div class="agent-name">{{coBrandedAgentDTO.agentInfo.firstName}}
                                        {{coBrandedAgentDTO.agentInfo.lastName}}</div>
                                    <div class="agent-title">{{coBrandedAgentDTO.agentInfo.jobTitle}}</div>
                                    <div class="agent-company-info">
                                        <div class="company-section">
                                            <div class="company-name">{{coBrandedAgentDTO.company?.name || 'Real-Finity Mortgage, LLC'}}</div>
                                            <div class="company-address">{{coBrandedAgentDTO.agentInfo.address1 || '929 Alton Road Suite 500, Miami, FL 33139'}}</div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Contact Column -->
                                <div class="col-12 col-sm-12 col-md-12 col-lg-4">
                                    <div class="contact-section">
                                        <div class="email-link" (click)="OnSendEmail()">Email me</div>
                                        <div class="website-link" *ngIf="coBrandedAgentDTO.agentInfo.website">Visit my
                                            website</div>
                                        <div class="contact-info">
                                            <div class="contact-item" *ngIf="coBrandedAgentDTO.agentInfo.phone">
                                                <div class="contact-icon phone-icon">
                                                    <div class="icon-text">o</div>
                                                </div>
                                                <div class="contact-number">{{coBrandedAgentDTO.agentInfo.phone}}</div>
                                            </div>
                                            <div class="contact-item" *ngIf="coBrandedAgentDTO.agentInfo.mobilePhone">
                                                <div class="contact-icon mobile-icon">
                                                    <div class="icon-text">c</div>
                                                </div>
                                                <div class="contact-number">{{coBrandedAgentDTO.agentInfo.mobilePhone}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!--Force Realtor to show up with LO viewing realtor client-->
            <ng-container *ngIf="coBranding == 'ForceRealtor'">
                <div class="row">
                    <!-- Realtor Agent -->
                    <div class="col-12 col-md-6">
                        <div class="agent-card" *ngIf="RealtorCoBrandingDTO$ | async as realtorDTO">
                            <div class="row">
                                <!-- Image Column -->
                                <div class="col-12 col-sm-3 col-md-3 agent-info">
                                    <img class="agent-image" [src]="realtorDTO.agentInfo.profileImageUrl"
                                        [alt]="realtorDTO.agentInfo.firstName + ' ' + realtorDTO.agentInfo.lastName" />
                                </div>
                                <!-- Info Column -->
                                <div class="col-12 col-sm-9 col-md-9 col-lg-5">
                                    <div class="agent-name">{{realtorDTO.agentInfo.firstName}}
                                        {{realtorDTO.agentInfo.lastName}}</div>
                                    <div class="agent-title">{{realtorDTO.agentInfo.jobTitle}}</div>
                                    <div class="agent-company-info">
                                        <div class="company-section">
                                            <div class="company-name">{{realtorDTO.company?.name || 'Real-Finity Mortgage, LLC'}}</div>
                                            <div class="company-address">{{realtorDTO.agentInfo.address1 || '929 Alton Road Suite 500, Miami, FL 33139'}}</div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Contact Column -->
                                <div class="col-12 col-sm-12 col-md-12 col-lg-4"> 
                                    <div class="contact-section">
                                        <div class="email-link" (click)="OnSendEmail()">Email me</div>
                                        <div class="website-link" *ngIf="realtorDTO.agentInfo.website">Visit my website
                                        </div>
                                        <div class="contact-info">
                                            <div class="contact-item" *ngIf="realtorDTO.agentInfo.phone">
                                                <div class="contact-icon phone-icon">
                                                    <div class="icon-text">o</div>
                                                </div>
                                                <div class="contact-number">{{realtorDTO.agentInfo.phone}}</div>
                                            </div>
                                            <div class="contact-item" *ngIf="realtorDTO.agentInfo.mobilePhone">
                                                <div class="contact-icon mobile-icon">
                                                    <div class="icon-text">c</div>
                                                </div>
                                                <div class="contact-number">{{realtorDTO.agentInfo.mobilePhone}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Main Agent -->
                    <div class="col-12 col-md-6">
                        <div class="agent-card" *ngIf="LgvUserSvc.AgentDTO$ | async as agentDTO">
                            <div class="row">
                                <!-- Image Column -->
                                <div class="col-12 col-sm-3 col-md-3 agent-info">
                                    <img class="agent-image" [src]="agentDTO.agentInfo.profileImageUrl"
                                        [alt]="agentDTO.agentInfo.firstName + ' ' + agentDTO.agentInfo.lastName" />
                                </div>
                                <!-- Info Column -->
                                <div class="col-12 col-sm-9 col-md-9 col-lg-5">
                                    <div class="agent-name">{{agentDTO.agentInfo.firstName}}
                                        {{agentDTO.agentInfo.lastName}}</div>
                                    <div class="agent-title">{{agentDTO.agentInfo.jobTitle}}</div>
                                    <div class="agent-company-info">
                                        <div class="company-section">
                                            <div class="company-name">{{agentDTO.company?.name || 'Real-Finity Mortgage, LLC'}}</div>
                                            <div class="company-address">{{agentDTO.agentInfo.address1 || '929 Alton Road Suite 500, Miami, FL 33139'}}</div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Contact Column -->
                                <div class="col-12 col-sm-12 col-md-12 col-lg-4"> 
                                    <div class="contact-section">
                                        <div class="email-link" (click)="OnSendEmail()">Email me</div>
                                        <div class="website-link" *ngIf="agentDTO.agentInfo.website">Visit my website
                                        </div>
                                        <div class="contact-info">
                                            <div class="contact-item" *ngIf="agentDTO.agentInfo.phone">
                                                <div class="contact-icon phone-icon">
                                                    <div class="icon-text">o</div>
                                                </div>
                                                <div class="contact-number">{{agentDTO.agentInfo.phone}}</div>
                                            </div>
                                            <div class="contact-item" *ngIf="agentDTO.agentInfo.mobilePhone">
                                                <div class="contact-icon mobile-icon">
                                                    <div class="icon-text">c</div>
                                                </div>
                                                <div class="contact-number">{{agentDTO.agentInfo.mobilePhone}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </div>
</div>